export function IsGranted(roles: string[], matchAnyRole: boolean = false) {
  return function decorator(target: any) {
    target.isGranted = roles;
    target.matchAnyRole = matchAnyRole;
  }
}
